export default __webpack_public_path__ + "static/media/ces.3b112e9c.png";